import {ApplicationBase} from '../../shared/data-objects/application-base';
import {PlumberDetails} from '../../shared/data-objects/plumber-details';
import {WorkrequestSrpDetails} from './workrequest-srp-details';
/**
 * Created by Boris on 14/02/2017.
 */
export class Srp extends ApplicationBase {
  plumberDetails: PlumberDetails;
  workrequestDetails: WorkrequestSrpDetails;
  constructor() {
    super();
    this.plumberDetails = new PlumberDetails();
    this.applicationType = 'SRP';
  }
}



// WEBPACK FOOTER //
// ./src/app/create-application/srp-form/srp.ts